module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-standside-2400.2b9e06e0.svg";